import { createAsyncThunk } from '@reduxjs/toolkit';
import { GoogleMerchantSettingsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGetGoogleMerchantSettingsDTO,
  IGetGoogleMerchantSettingsResponse,
  IUpdateGoogleMerchantSettingsDTO,
  IUpdateGoogleMerchantSettingsResponse,
} from '@/models/googleMerchantSettings.model';
import { SLICE_NAME } from './models';

export const getGoogleMerchantSettings = createAsyncThunk<
  IGetGoogleMerchantSettingsResponse,
  IGetGoogleMerchantSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getGoogleMerchantSettings`,
  async (params) => {
    const response = await GoogleMerchantSettingsAPI.getMerchantSettings(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateGoogleMerchantSettings = createAsyncThunk<
  IUpdateGoogleMerchantSettingsResponse,
  IUpdateGoogleMerchantSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateGoogleMerchantSettings`,
  async (data) => {
    const response = await GoogleMerchantSettingsAPI.updateMerchantSettings(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
